import { render, staticRenderFns } from "./MantraEdit.vue?vue&type=template&id=26f48ece&scoped=true&"
import script from "./MantraEdit.vue?vue&type=script&lang=js&"
export * from "./MantraEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f48ece",
  null
  
)

export default component.exports